import React, { useEffect } from 'react';

const ExternalAccountListeners = ({ eventEmitter, applyStoreAction }) => {
    const listen = () => {
        eventEmitter.on('account_linked', account => {
            applyStoreAction({
                type: 'EXTERNAL_ACCOUNT_ADD_SOCKET',
                payload: { account }
            });
        });

        eventEmitter.on('account_unlinked', account => {
            applyStoreAction({
                type: 'EXTERNAL_ACCOUNT_REMOVE_SOCKET',
                payload: { accountId: account.id }
            });
        });
    }

    useEffect(listen, []);

    return null;
}

export default ExternalAccountListeners;
